
/**
 * A debounced function for text input
 * 
 * @param {*} fn 
 * @param {*} delay 
 * @returns 
 */
export function debounce(fn, delay) {

  let timer = null

  return function (...args) {

    if (timer) clearTimeout(timer)

    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}



// WEBPACK FOOTER //
// ./src/lib/debounce.js